<template>
    <div style="width: 80%;margin-top: 5%;margin-left: 10%">
        <el-steps :active="active"
                  finish-status="success"
                  align-center>
            <el-step title="验证手机号">
            </el-step>
            <el-step title="填写新密码"></el-step>
            <el-step title="成功"></el-step>
        </el-steps>
        <div class="content" v-if="oneFormDiv">
            <el-form :model="oneForm" status-icon :rules="oneRules" ref="oneForm" class="form" size="medium">
                <el-form-item label="手机号码"  prop="mobile">
                    <el-input type="input" v-model="oneForm.mobile"></el-input>
                </el-form-item>
                <!--<el-form-item label="商户名称" prop="name">-->
                    <!--<el-input v-model="oneForm.name"></el-input>-->
                <!--</el-form-item>-->
                <el-form-item label="验证码" prop="code">
                    <el-input type="input" v-model="oneForm.code">
                        <template slot="append">
                            <el-button type="primary" :disabled="codeButton" @click="sendCode">{{codeButtonHtml}}</el-button>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button style="margin-top: 12px;"  @click="next">下一步</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content" v-if="twoFormDiv">
            <el-form :model="twoForm" status-icon :rules="twoRules" ref="twoForm" class="form" size="medium">
                <el-form-item label="新密码"  prop="password">
                    <el-input type="input" v-model="twoForm.password"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="repeatPwd">
                    <el-input type="input" v-model="twoForm.repeatPwd"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button style="margin-top: 12px;"  @click="next">下一步</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content" v-if="threeFormDiv">
            <el-alert
                    title="操作成功......."
                    type="success"
                    center
                    show-icon>{{jumpTimes}}秒后跳转登录界面
            </el-alert>
        </div>
          <el-button
            type="primary"
            plain
            @click.stop="toLogin"
            style="position: fixed;left: 5%;top: 5%;"
          >返回首页</el-button>
    </div>

</template>

<script>
    import { FgtPwdCode, validFgtPwdCode,resetPwd} from "@/api/login/login";
    import { resolveUrlPath } from '@/util/util'
    export default {
        data() {
            return {
                active: 0,
                oneForm: {},
                twoForm: {},
                oneFormDiv: true,
                twoFormDiv: false,
                threeFormDiv: false,
                isShowPassword: true,
                jumpTimes: 3,
                oneRules: {
                    mobile: [
                        { required: true, message: '请输入手机号码', trigger: 'blur' },
                        { min: 11, max: 11, message: '请输入11位手机号码', trigger: 'blur' }
                    ],
                    code: [
                        { required: true, message: '请输入短信验证码', trigger: 'blur' }
                    ]

                },
                twoRules: {
                    password: [
                        { required: true, message: '请输入密码', trigger: 'change' },
                        { min: 6, max: 16 , message: '请输6-16位的密码', trigger: 'blur' }
                    ],
                    repeatPwd: [
                        { required: true, message: '请输入密码', trigger: 'change' },
                        { min: 6, max: 16 , message: '请输6-16位的密码', trigger: 'blur' }
                    ]
                },
                codeButton: false,
                codeButtonHtml: "获取验证码"
            };
        },
        created () {
        },
        methods: {
            toLogin(){
                this.$router.push({
                        path: resolveUrlPath("login", "登录")
                    })
            },
            next() {
                if(this.active == 0){
                    this.$refs["oneForm"].validate((valid) => {
                        if (valid) {
                            validFgtPwdCode(this.oneForm).then(response => {
                                if(response.code == '200'){
                                    this.oneFormDiv = false
                                    this.active = 1
                                    this.twoFormDiv = true
                                    // if(data.isHadAccount == 'YES'){
                                    //     this.isShowPassword = false
                                    // }
                                }else{
                                    this.$message.error(response.message);
                                }
                            })
                        } else {
                            this.$message.error("请填写正确的表单数据");
                            return false;
                        }
                    });
                }else if(this.active == 1){
                    this.$refs["twoForm"].validate((valid) => {
                        if (valid) {
                            if(this.twoForm.password === this.twoForm.repeatPwd){
                            this.twoForm.mobile = this.oneForm.mobile
                            this.twoForm.clientType = 'JOINS_AGENT'
                            resetPwd(this.twoForm).then(response => {
                                if(response.code == '200'){
                                    // this.twoForm.departPositionId = data.departPositionId
                                    // this.twoForm.departId = data.departId
                                    this.twoFormDiv = false
                                    this.active = 2
                                    this.jumpTimer();
                                    this.threeFormDiv = true
                                }else{
                                    this.$message.error(response.message);
                                }
                            })
                            }
                        } else {
                            this.$message.error("请填写正确的表单数据");
                            return false;
                        }
                    });
                } 

            },
            
            sendCode(){
                this.time=120;
                this.codeButton=true;
                this.timer();
                if(undefined == this.oneForm.mobile){
                    this.$message({
                        message: '请填写手机号码',
                        type: 'warning'
                    });
                    return
                }
                FgtPwdCode(this.oneForm.mobile).then(response => {
                    if(response.code == '200'){
                        this.$message({
                            message: '验证码已发送，请查收',
                            type: 'success'
                        });
                    }else{
                        this.$message.error(response.message);
                    }
                })
            },
            timer(){
                if (this.time > 0) {
                    this.time--;
                    this.codeButtonHtml=this.time+"s,后重新获取验证码";
                    setTimeout(this.timer, 1000);
                } else{
                    this.time=0;
                    this.codeButtonHtml="获取验证码";
                    this.codeButton=false;
                }
            },
            jumpTimer(){
                if (this.jumpTimes != 0) {
                    this.jumpTimes --
                    setTimeout(this.jumpTimer, 1000);
                }else{
                    clearInterval(this.jumpTimer)
                    this.$router.push({
                        path: resolveUrlPath("login", "登录")
                    })
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .content {
        width: 40%;
        margin: 0 auto;
        padding: 20px 0;
        .menu {
            display: flex;
            justify-content: center;
        }
    }
    .form {
        border-bottom: 1px solid #f0f0f0;
        margin-bottom: 5px;
        padding: 20px;
        .el-form-item {
            margin-bottom: 5px;
        }
        &.bg {
            border-bottom: none;
            background: #fdfdfd;
        }
    }
</style>
